import { render, staticRenderFns } from "./StatsPieChart.vue?vue&type=template&id=21dcdd9f&"
import script from "./StatsPieChart.vue?vue&type=script&lang=js&"
export * from "./StatsPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports